import { render, staticRenderFns } from "./HomePagination.vue?vue&type=template&id=4c3cc500&lang=pug&"
import script from "./HomePagination.vue?vue&type=script&lang=js&"
export * from "./HomePagination.vue?vue&type=script&lang=js&"
import style0 from "./HomePagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3cc500')) {
      api.createRecord('4c3cc500', component.options)
    } else {
      api.reload('4c3cc500', component.options)
    }
    module.hot.accept("./HomePagination.vue?vue&type=template&id=4c3cc500&lang=pug&", function () {
      api.rerender('4c3cc500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomePagination.vue"
export default component.exports